import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { PendingActionUtils } from 'app/page/orders/utils/pending-action-utils';
import { PendingType } from 'app/page/orders/redux/model/pending-type';
import { CustomerInformation } from 'app/page/orders/model/customer-information';
import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';
import { SwitchLink } from 'app/components/common/switch-link';
import userLargeIcon from 'app/resources/user-large.svg';
import { i18n } from 'app/i18n';
import { NavigationService, navigationService } from 'app/service/navigation-service';
import {
    selectBillingAccounts,
    selectPendingActions,
    selectBillingAccountIdOrThrow,
} from 'app/page/orders/redux/order-selectors';

export const AccountSwitchLink: FC = () => {
    const selectedBillingAccountId = useSelector(selectBillingAccountIdOrThrow);
    const billingAccounts = useSelector(selectBillingAccounts);
    const pendingActions = useSelector(selectPendingActions);

    const pendingCustomerInformation: boolean = PendingActionUtils.isActionWithIdPending(pendingActions, {
        type: PendingType.LOAD_CUSTOMER_INFORMATION,
        id: selectedBillingAccountId,
    });

    if (billingAccounts.length <= 1 || pendingCustomerInformation) {
        return null;
    }

    const customerInformation: CustomerInformation | undefined = BillingAccountUtils.getBillingAccount(
        billingAccounts,
        selectedBillingAccountId,
    ).customerInformation;

    if (!customerInformation) {
        throw new Error('Customer information must be present.');
    }

    const { fullName, billingAccountId } = customerInformation;

    return (
        <SwitchLink
            title={fullName}
            text={billingAccountId}
            icon={{
                src: userLargeIcon,
                alt: i18n.image.user,
            }}
            onClick={() => navigationService.goToPath(NavigationService.CHOOSE_ACCOUNT)}
        />
    );
};
